import React, { useEffect, Suspense } from "react";
import Footer from "./Footer";
import { Routes, Route, Link, Outlet, useLocation } from "react-router-dom";
import Header from "./SiteNav";
import PageNotFound from "../pages/PageNotFound";
import { scrollTop } from "../../helper";
import { toggleHamburger } from "../../store/publicMethods";
import { useDispatch, useSelector } from "react-redux";
import Preloader from "../ui/Preloader";
import { ROUTE_BASENAME } from "../../config/constants";
import PrivateRoutes from "./PrivateRoutes";
import PrivateRoutesSuper from "./PrivateRoutesSuper";
import { PageLoader } from "../ui/common/LoadingSpinner";
import Poll from "../pages/t-hub/Poll";
import VirtualEvent from "../pages/t-hub/VirtualEvent";
import PrivateRoutesCompany from "./PrivateRoutesCompany";
import Sudoku from "../pages/t-hub/Games/Sudoku";
import TicTacToe from "../pages/t-hub/Games/TicTacToe/TicTacToe";
import Thub from "../pages/main/Thub";
import VerifyUser from "../pages/company-admin-panel/VerifyUser";
import ChannelDisplay from "../pages/main/template-parts/ChannelDisplay";
import ResetPassword from "../pages/company-admin-panel/ResetPassword";

const Index = React.lazy(() => import("../pages/main/Index"));
const Home = React.lazy(() => import("../pages/main/Home"));
const Profile = React.lazy(() => import("../pages/main/Profile"));
const MyList = React.lazy(() => import("../pages/main/MyList"));
const Notifications = React.lazy(() => import("../pages/main/Notifications"));
const TagSearch = React.lazy(() => import("../pages/main/TagSearch"));
const Search = React.lazy(() => import("../pages/main/Search"));
const UserPanel = React.lazy(() => import("../pages/main/UserPanel"));
const InHouse = React.lazy(() => import("../pages/main/InHouse"));
const Podcaster = React.lazy(() => import("../pages/main/Podcaster"));
const TodoList = React.lazy(() => import("../pages/t-hub/TodoList"));
const Sos = React.lazy(() => import("../pages/t-hub/SOS"));
const Quiz = React.lazy(() => import("../pages/t-hub/Quiz"));
const Games = React.lazy(() => import("../pages/t-hub/Games"));
const PlayGame = React.lazy(() => import("../pages/t-hub/PlayGame"));
const Survey = React.lazy(() => import("../pages/t-hub/Survey"));
const SurveyDetail = React.lazy(() => import("../pages/t-hub/SurveyDetail"));
const Chat = React.lazy(() => import("../pages/t-hub/Chat"));
const Helpdesk = React.lazy(() => import("../pages/t-hub/Helpdesk"));
const Feedback = React.lazy(() => import("../pages/t-hub/Feedback"));
const Announcements = React.lazy(() => import("../pages/t-hub/Announcements"));
const IdeaBoard = React.lazy(() => import("../pages/t-hub/IdeaBoard"));
const HallOfFame = React.lazy(() => import("../pages/t-hub/HallOfFame"));
const EMagazine = React.lazy(() => import("../pages/t-hub/EMagazine"));
const FAQ = React.lazy(() => import("../pages/t-hub/FAQ"));
const Login = React.lazy(() => import("../pages/company-admin-panel/SignIn"));
const LoginSuper = React.lazy(() =>
  import("../pages/super-admin-panel/SignIn")
);
const CompanyAdminPanel = React.lazy(() =>
  import("../pages/company-admin-panel/CompanyAdminPanel")
);
const SuperAdminPanel = React.lazy(() =>
  import("../pages/super-admin-panel/SuperAdminPanel")
);
const VerifyOtp = React.lazy(() =>
  import("../pages/company-admin-panel/VerifyOtp")
);
const Contact = React.lazy(() => import("../pages/main/Contact"));
const Privacy = React.lazy(() => import("../pages/main/Privacy"));
const SupportedDevices = React.lazy(() =>
  import("../pages/main/SupportedDevices")
);
const ManagePreferences = React.lazy(() =>
  import("../pages/main/ManagePreferences")
);
const Help = React.lazy(() => import("../pages/main/Help"));

function Main() {
  const location = useLocation();
  const dispatch = useDispatch();
  // const profileData = useSelector((state) => state.auth.myProfile);
  const isLoading = useSelector((state) => state.public.isLoading);
  const searchParams = new URLSearchParams(location.search);
  const token = searchParams.get("token");
  useEffect(() => {
    //dispatch(publicActions.isLoading(true));
    let tout;
    tout = setTimeout(() => scrollTop(), 100);
    dispatch(toggleHamburger(false));
    return () => {
      clearTimeout(tout);
    };
  }, [location.pathname]);

  return (
    <>
      {isLoading && <PageLoader />}
      <Header />
      <Suspense>
          <Routes>
            <Route path="/" element={<Index />} />
            <Route path={`/${ROUTE_BASENAME}`} element={<Index />} />
            {/* {profileData?.user?.is_superuser === false ?( */}
            <Route
              path="/home"
              element={
                <PrivateRoutes>
                  <Home />
                </PrivateRoutes>
              }
            ></Route>
            {/* ):""} */}

            <Route
              path="/my-list"
              element={
                <PrivateRoutes>
                  <MyList />
                </PrivateRoutes>
              }
            ></Route>

            <Route
              path="/notifications"
              element={
                <PrivateRoutes>
                  <Notifications />
                </PrivateRoutes>
              }
            ></Route>

            <Route
              path="/tag-search"
              element={
                <PrivateRoutes>
                  <TagSearch />
                </PrivateRoutes>
              }
            ></Route>

            <Route
              path="/search"
              element={
                <PrivateRoutes>
                  <Search />
                </PrivateRoutes>
              }
            ></Route>

            <Route
              path="/in-house"
              element={
                <PrivateRoutes>
                  <InHouse />
                </PrivateRoutes>
              }
            ></Route>

            <Route
              path="/in-house/:slug"
              element={
                <PrivateRoutes>
                  <InHouse />
                </PrivateRoutes>
              }
            ></Route>

            <Route
              path="/podcaster"
              element={
                <PrivateRoutes>
                  <Podcaster />
                </PrivateRoutes>
              }
            ></Route>

            <Route
              path="/channel"
              element={
                <PrivateRoutes>
                  <ChannelDisplay />
                </PrivateRoutes>
              }
            ></Route>

            <Route
              path="/podcaster/:slug"
              element={
                <PrivateRoutes>
                  <Podcaster />
                </PrivateRoutes>
              }
            ></Route>

            <Route
              path="profile"
              element={
                <PrivateRoutes>
                  <Profile />
                </PrivateRoutes>
              }
            ></Route>
            <Route
              path="t-hub"
              element={
                <PrivateRoutes>
                  <Thub />
                </PrivateRoutes>
              }
            ></Route>
            <Route
              path="todolist"
              element={
                <PrivateRoutes>
                  <TodoList />
                </PrivateRoutes>
              }
            ></Route>
            <Route
              path="survey"
              element={
                <PrivateRoutes>
                  <Survey />
                </PrivateRoutes>
              }
            ></Route>
            <Route
              path="survey/:id"
              element={
                <PrivateRoutes>
                  <SurveyDetail />
                </PrivateRoutes>
              }
            ></Route>
            <Route
              path="quiz"
              element={
                <PrivateRoutes>
                  <Quiz />
                </PrivateRoutes>
              }
            ></Route>
            <Route
              path="games"
              element={
                <PrivateRoutes>
                  <Games />
                </PrivateRoutes>
              }
            ></Route>
            <Route
              path="games/sudoku"
              element={
                <PrivateRoutes>
                  <Sudoku />
                </PrivateRoutes>
              }
            ></Route>
            <Route
              path="games/tictactoe"
              element={
                <PrivateRoutes>
                  <TicTacToe />
                </PrivateRoutes>
              }
            ></Route>
            <Route
              path="chat"
              element={
                <PrivateRoutes>
                  <Chat />
                </PrivateRoutes>
              }
            ></Route>
            <Route
              path="ideaboard"
              element={
                <PrivateRoutes>
                  <IdeaBoard />
                </PrivateRoutes>
              }
            ></Route>
            <Route
              path="hall-of-fame"
              element={
                <PrivateRoutes>
                  <HallOfFame />
                </PrivateRoutes>
              }
            ></Route>
            <Route
              path="helpdesk"
              element={
                <PrivateRoutes>
                  <Helpdesk />
                </PrivateRoutes>
              }
            ></Route>
            <Route
              path="feedback"
              element={
                <PrivateRoutes>
                  <Feedback />
                </PrivateRoutes>
              }
            ></Route>
            <Route
              path="announcements"
              element={
                <PrivateRoutes>
                  <Announcements />
                </PrivateRoutes>
              }
            ></Route>
            <Route
              path="sos"
              element={
                <PrivateRoutes>
                  <Sos />
                </PrivateRoutes>
              }
            ></Route>
            <Route
              path="userPanel"
              element={
                <PrivateRoutes>
                  <UserPanel />
                </PrivateRoutes>
              }
            ></Route>
            <Route
              path="e-magazine"
              element={
                <PrivateRoutes>
                  <EMagazine />
                </PrivateRoutes>
              }
            ></Route>
            <Route
              path="virtual-event"
              element={
                <PrivateRoutes>
                  <VirtualEvent />
                </PrivateRoutes>
              }
            ></Route>
            <Route
              path="faq"
              element={
                <PrivateRoutes>
                  <FAQ />
                </PrivateRoutes>
              }
            ></Route>
            <Route
              path="polls"
              element={
                <PrivateRoutes>
                  <Poll />
                </PrivateRoutes>
              }
            ></Route>

            {/* <Route
            path="company-admin-panel"
            element={
              <PrivateRoutes>
                <CompanyAdminPanel />
              </PrivateRoutes>
            }
          ></Route> */}

            <Route
              path="company-admin-panel"
              element={
                <PrivateRoutesCompany>
                  <CompanyAdminPanel />
                </PrivateRoutesCompany>
              }
            ></Route>

            <Route path="company-admin-panel/login" element={<Login />} />
            {/* <Route path="company-admin-panel" element={<CompanyAdminPanel />} /> */}
            <Route
              path="company-admin-panel/verify-otp"
              element={<VerifyOtp />}
            />
            <Route
              path="/company-admin-panel/verifyuser"
              element={<VerifyUser token={token} />}
            />
            <Route
              path="/company-admin-panel/resetpassword"
              element={<ResetPassword token={token} />}
            />

            <Route path="super-admin-panel/login" element={<LoginSuper />} />

            <Route
              path="super-admin-panel"
              element={
                <PrivateRoutesSuper>
                  <SuperAdminPanel />
                </PrivateRoutesSuper>
              }
            ></Route>

            {/* <Route path="super-admin-panel" element={<SuperAdminPanel />} /> */}

            {/* <Route path=":id" element={<h1>User Profile</h1>} />
        <Route path="me" element={<h1>Own User Profile</h1>} /> */}
            <Route path="privacy" element={<Privacy />} />
            <Route path="contact-us" element={<Contact />} />
            <Route path="supported-devices" element={<SupportedDevices />} />
            <Route path="manage-preferences" element={<ManagePreferences />} />
            <Route path="manage-preferences" element={<ManagePreferences />} />
            <Route path="help" element={<Help />} />
            <Route path="*" element={<PageNotFound />} />
          </Routes>
      </Suspense>


      <Footer />
    </>
  );
}

export default Main;
